// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");

function argsToString(args, exprToStr) {
  return args.map(function (arg, i) {
                return "" + String(i + 1 | 0) + ": " + (
                        arg.length === 0 ? "?" : Curry._1(exprToStr, arg)
                      ) + "";
              }).join("\n");
}

function unifErrToStr(err, exprToStr, frmExprToStr) {
  if (typeof err === "number") {
    return "Details of the error were not stored.";
  }
  switch (err.TAG | 0) {
    case /* DisjCommonVar */0 :
        var arrow = String.fromCharCode(8594);
        return "Unsatisfied disjoint, common variable " + Curry._1(exprToStr, [err.commonVar]) + ":\n" + ("" + Curry._1(frmExprToStr, [err.frmVar1]) + " " + arrow + " " + Curry._1(exprToStr, err.expr1) + "\n") + ("" + Curry._1(frmExprToStr, [err.frmVar2]) + " " + arrow + " " + Curry._1(exprToStr, err.expr2) + "");
    case /* Disj */1 :
        var arrow$1 = String.fromCharCode(8594);
        return "Missing disjoint " + Curry._1(exprToStr, [err.var1]) + "," + Curry._1(exprToStr, [err.var2]) + ":\n" + ("" + Curry._1(frmExprToStr, [err.frmVar1]) + " " + arrow$1 + " " + Curry._1(exprToStr, err.expr1) + "\n") + ("" + Curry._1(frmExprToStr, [err.frmVar2]) + " " + arrow$1 + " " + Curry._1(exprToStr, err.expr2) + "");
    case /* UnprovedFloating */2 :
        return "Could not prove this floating statement:\n" + Curry._1(exprToStr, err.expr);
    case /* NoUnifForAsrt */3 :
        var arrow$2 = String.fromCharCode(8594);
        return "Could not find a unification for assertion:\n" + ("" + Curry._1(frmExprToStr, err.asrtExpr) + "\n" + arrow$2 + "\n" + Curry._1(exprToStr, err.expr) + "");
    case /* NoUnifForArg */4 :
        var args = err.args;
        var colon = args.length === 0 ? "" : ":";
        return "Could not unify essential hypothesis #" + String(err.errArgIdx + 1 | 0) + "" + colon + "\n" + argsToString(args, exprToStr);
    case /* NewVarsAreDisabled */5 :
        var errArgIdx = err.errArgIdx;
        var args$1 = err.args;
        var what = args$1.length === errArgIdx ? "assertion" : "essential hypothesis #" + String(errArgIdx + 1 | 0) + "";
        var colon$1 = args$1.length === 0 ? "" : ":";
        return "New variables are not allowed, but one had to be created" + (" when unifying " + what + "" + colon$1 + "\n") + argsToString(args$1, exprToStr);
    
  }
}

exports.unifErrToStr = unifErrToStr;
/* No side effect */
